import _ from 'lodash';
import React from 'react';
import AppLink from '../AppLink/AppLink';
import { ROUTE_PATHS } from '../../../routes/Routes';

interface IAccountLinkProps {
  uuid?: string;
  displayText?: string;
}

export default function AccountLink({ uuid, displayText }: IAccountLinkProps) {
  if (_.isEmpty(uuid) || _.isEmpty(displayText)) {
    return null;
  }

  const path = `/${ROUTE_PATHS.ACCOUNTS}/${uuid}`;

  return (
    <AppLink to={path}>{displayText}</AppLink>
  );
}
